import React from 'react';
import Loader from '../Loader/Loader';

export default function Content({ loading, children }) {
    return <div>{loading ? <Loader /> : children}</div>;
}
